import React, { useEffect, useState } from "react";
import Container from "../../common/Container";
import Action from "../../common/Actions"
import "../../index.css";
import SearchIcon from "@mui/icons-material/Search";
import InputWithIcon from "../../common/InputWithIcon";
import { TH, TD, TR, Thead, Tbody } from "../../styled/table";
import Add from "@mui/icons-material/Add";
import Button from "../../common/Button";
import PaginationDiv from "../../common/PaginationDiv";
import CustomAddPage from "../../components/custom-pages/CustomAddModal"
import { createDocument, deleteDocumentById, getAllData } from "../../apis/customApiHandler";
import { convertToIndianTimezoneAndGetDate, handleDownClick, handleUpClick } from "../../utils/helpers";
import { LinearProgress } from "@mui/material";
import checkPermission from "../../utils/checkPermission";


function BenchMarkProduct() {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = React.useState(1);
  const [search, setSearch] = useState("")
  const [benchmarks, setBenchMarks] = useState([])
  const [benchmark, setBenchMarkProduct] = useState({})
  const [totalData, setTotalData] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [loading, setLoading] = useState(false)
  const currentUser = JSON.parse(localStorage.getItem("user"))

  const getBenchMarkProduct = async () => {
    setLoading(true)
    const data = await getAllData("/master/benchmark/getBenchMarkProduct", {page, limit, search});
    setBenchMarks(data?.data)
    setTotalData(data?.totalData)
    setTotalPage(data?.totalPage)
    setTotalPage(data?.totalPage)
    setLoading(false)
  }
  useEffect(() => {
    getBenchMarkProduct();
  }, [search, limit, page ])

  const list = [
    {
      name: "Edit",
     condition: checkPermission([
    {
        permission: "masters",
        subPermission: ["UPDATE"]
    },
], currentUser),
      onClick: (benchmark) => {
        setBenchMarkProduct(benchmark);
        setShowEditModal(true);
      },
      className: "text-grey",
    },
    {
      name: "Delete",
     condition: checkPermission([
    {
        permission: "masters",
        subPermission: ["DELETE"]
    },
], currentUser),
      onClick: async (benchmark) => {
        setBenchMarkProduct(benchmark);
        await createDocument("/master/benchmark/updateBenchMarkProduct?_id=" +  benchmark?._id, {deleted: true});
        await getBenchMarkProduct()
      },
      className: "text-error",
    },
  ];
  return (
    <Container>
      <div className="flex flex-col md:flex-row justify-between">
        <div className="grid grid-col-1 col-span-2 md:col-span-1 flex flex-col">
          <div className="font-semibold text-[24px]"> BenchMark Product</div>
        </div>

        <div className="flex flex-row text-secondary h-12 gap-3 text-xl">
          <div className="">
            <Button
              text="Add New BenchMarkProduct"
              disabled = {!checkPermission([
                {
                    permission: "masters",
                    subPermission: ["CREATE"]
               ,},
            ], currentUser)}
              className="w-full flex flex-row border border-1 border-black items-center px-3 rounded-md h-12 text-[16px] font-medium text-white bg-dark-blue gap-3"
              Icon={<Add color="inherit" />}
              onClick={() => setShowAddModal(true)}
            />
          </div>
        </div>
      </div>
      <div className="mt-5">
        <InputWithIcon
          placeholder="Search for BenchMarkProduct..."
          variant="outlined"
          setData={setSearch}
          Icon={<SearchIcon className="text-dark-grey" />}
          className="w-80 border border-gray-300 items-center px-2 rounded-md h-12 text-[16px] shadow-sm"
          inputClass="text-[16px]"
        />
      </div>
      <table className="w-full table">
        <Thead className="flex flex-row justify-between w-full">
          <tr className=" flex flex-row justify-between w-full">
            {/* <TH className="" type="checkbox"> <input type="checkbox"></input></TH> */}
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setBenchMarks} field={"name"} >Bench Mark Product Name</TH>
            <TH  field={"company"} > Company</TH>
            <TH  field={"tyreSize"} > Tyre Size</TH>
            <TH handleUpClick= {handleUpClick} handleDownClick={handleDownClick} setData={setBenchMarks} field={"createdAt"} > Created On</TH>
            <TH> Actions</TH>
          </tr>
        </Thead>
        {loading ? <LinearProgress color="secondary" /> :
          <Tbody className="flex flex-col justify-between w-full">
            {benchmarks?.length ? benchmarks?.map((entry, index) => {
              if (true)
                return (
                  <TR key={entry?._id} className="">
                    {/* <TD className="ml-2 text-center justify-center " type="checkbox"> <input type="checkbox"></input> </TD> */}
                    <TD> {entry.productName} </TD>
                    <TD> {entry.company?.name} </TD>
                    <TD> {entry.tyreSize?.name} </TD>
                    <TD> {convertToIndianTimezoneAndGetDate(entry.createdAt)} </TD>
                    <TD className="text-center"> <Action list={list} data={entry} /> </TD>
                  </TR>
                );
            }): <div className= "w-full text-semibold text-center text-lightGrey p-3"> No Data Found </div>}
          </Tbody>
        }
      </table>2
      <PaginationDiv
        page={page}
        setPage={setPage}
        length={totalData}
        limit={limit}
        setLimit={setLimit}
      />
      {showAddModal && <Create handleClick={async () => { setShowAddModal(false); await getBenchMarkProduct() }} />}
      {showEditModal && <Create data={benchmark} handleClick={async () => { setShowEditModal(false); await getBenchMarkProduct() }} />}
    </Container>
  )
}
function Create({ data, handleClick }) {
  const [initialValues, setInitialValues] = React.useState({
    productName: data?.productName || "",
    materialNo: data?.materialNo || "",
    tyreSize: data?.tyreSize?._id ?? "",
    company: data?.company?._id ?? ""
  });
  const [companies, setCompanies] = useState([]);
  const [sizes, setSizes] = useState([]);

    const getBenchMarkCompany  = async()=>{
      const data = await getAllData("/master/benchmark/getBenchMarkCompany", {});
      setCompanies(data?.data)
    }
    const getTyreSize  = async()=>{
      const data = await getAllData("/master/product/getTyreSize", {});
      setSizes(data?.data)
    }
    useEffect(()=>{
        getBenchMarkCompany();
        getTyreSize();
    }, [])

  const inputFields = [
    {
      name: "productName",
      label: "BenchMark Product Name",
      type: "text",
      required: true,
    },
    {
      name: "company",
      label: "Company",
      type: "select",
      className: "w-full col-span-2",
      options: companies?.map(role=> {return {label: role.name, value: role._id}}),
      required: true,
    },
    {
      name: "tyreSize",
      label: "Tyre Size",
      type: "select",
        className: "w-full col-span-2",
        options: sizes?.map(role=> {return {label: role.description, value: role._id}}),
        required: true,
    }
  ];
  return (
    <CustomAddPage
      pageTitle={data ? "Update BenchMark Product" : "Add BenchMark Product"}
      url={data ? "/master/benchmark/updateBenchMarkProduct" : "/master/benchmark/addBenchMarkProduct"}
      action={!data ? "create" : "post"}
      updateId={data?._id}
      queryKey="BenchMarkProduct"
      inputFields={inputFields}
      data={initialValues}
      setData={setInitialValues}
      handleClick={handleClick}
    />
  );
}
export default BenchMarkProduct